import { deeplinkNavigation } from './DeeplinkNavigationParams'

export const navigateHowToUse = () => {
  deeplinkNavigation({
    name: 'MediaWebView',
    title: '家族のお金メディア👨‍🎓',
    uri: 'https://www.osidori.co/app/cate.php?tab=3',
  })
}
